<template>
  <div>
    <!-- 面包屑导航 -->
    <div class="flexc-cen-x fixed">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{WZHYName}}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-select v-if="DianList.length>1" style="margin-left:20px;width:140px" size="mini" v-model="SelectStoresID" @change="changedian()" placeholder="门店">
           <el-option
                  v-for="item in DianList"
                  :key="item.ID"
                  :label="item.StoresName"
                  :value="item.ID">
            </el-option>
    </el-select>
    </div>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="flex-spc-x" style="padding-top:30px">
      <div>
        <el-form-item label="会员卡：" prop="RowType"  >
              <el-select clearable v-model="CardID" placeholder="请选择" size="mini" style="width:150px" >
                <el-option
                  v-for="item in ListMemberCard"
                  :key="item.ID"
                  :label="item.CardName"
                  :value="item.ID">
                </el-option>
              </el-select>
            </el-form-item>
        <el-form-item label="搜索：">
          <el-input size="mini" v-model="selectName" placeholder="输入姓名、手机号"></el-input>
        </el-form-item>
        <el-form-item label="">
            <el-button size="mini" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
      </div>
      <el-form-item>
        <el-button size="mini" type="primary" icon="el-icon-plus" @click="handleEdit()" v-if="q1 == true">添加{{WZHYName}}</el-button>
        <el-button size="mini" type="success"   @click="doupdExcl()" v-if="q1 == true">导入{{WZHYName}}</el-button>

        <el-button size="mini" type="warning"   @click="handleExport()" v-if="q1 == true">导出{{WZHYName}}</el-button>
        <el-button size="mini" type="danger" v-if="q8241==true"  @click="delAllMembersClick()"  >批量删除{{WZHYName}}</el-button>

      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table  :data="tableData" highlight-current-row v-loading="loading"  size="mini" element-loading-text="拼命加载中" style="width: 100%;" @selection-change="handleSelectionChange"> 
      <el-table-column  type="selection" width="60">
      </el-table-column>
        <el-table-column  prop="Name" label="姓名" width="120" >
          <template slot-scope="scope">
            <div class="flexc-cen-x">
              <img :src="scope.row.HeadUrl" v-if="scope.row.HeadUrl !='' " style="width:25px;height:25px;border-radius:100%" alt="">
              <img v-if="scope.row.HeadUrl =='' " src="../../assets/img/head.png" style="width:25px;height:25px;border-radius:100%" alt="">
              <div style="margin-left:5px">{{scope.row.Name}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column  prop="Phone" label="手机号" width="100" align="center">
        </el-table-column>
        <el-table-column label="持有会员卡"  width="400"   >
                            <template slot-scope="scope" >
                               <div style="width:400px;display:block;word-break: break-all;word-wrap: break-word">
                                <div class="ivu-table-cell"  v-for="vipitem in scope.row.listVip"  :label="vipitem.ID" :key="vipitem.index" >
                                <div style = "margin-top: 10px; padding: 6px 5px; border: 1px solid rgb(232, 234, 236); border-radius: 4px; margin-bottom: 10px; background-color: rgb(255, 255, 255); font-size: 13px;" >
                                <span class="ivu-badge-status ivu-badge" style="margin-left: 5px;"><span class="ivu-badge-status-dot ivu-badge-status-green"></span>
                                    <span class="ivu-badge-status-text"  v-if="vipitem.iskaika=='1' && vipitem.CardType =='1'">{{vipitem.CardName}} | 到期：{{vipitem.OverdueTime}} 余额:{{vipitem.CardNumber}}次</span>    
                                    <span class="ivu-badge-status-text"  v-if="vipitem.iskaika=='1' && vipitem.CardType =='2'">{{vipitem.CardName}} | 到期：无限期 余额:{{vipitem.CardNumber}}次</span>    
                                    <span class="ivu-badge-status-text"  v-if="vipitem.iskaika=='1' && vipitem.CardType =='3'">{{vipitem.CardName}} | 到期：{{vipitem.OverdueTime}} 余额:不限次数</span>    
                                    <span class="ivu-badge-status-text"  v-if="vipitem.iskaika=='1' && vipitem.CardType =='4'">{{vipitem.CardName}} | 到期：无限期 余额:{{vipitem.Amount}}元</span>    
                                    <span class="ivu-badge-status-text"  v-if="vipitem.iskaika=='1' && vipitem.CardType =='5'">{{vipitem.CardName}} | 到期：{{vipitem.OverdueTime}} 余额:{{vipitem.Amount}}元</span>    
                                    <span class="ivu-badge-status-text"  v-if="vipitem.iskaika=='0' ">{{vipitem.CardName}} | 未开卡</span>    
                                    <span class="ivu-badge-status-text"  v-if="vipitem.isStop=='1' ">  | 已停卡</span>    

                                </span> 
                                </div>
                                </div>
                                </div>
                             </template>

                            </el-table-column>

        <el-table-column v-if="isdengji == 1"  prop="LevelName" label="等级"  align="center">
        </el-table-column>
        <el-table-column v-if="isxynl == 1"  prop="CapacityName" label="能力"  align="center">
        </el-table-column>
        <el-table-column  prop="czAmount" label="储蓄金额(元)"  align="center" v-if="isCard == 0">
        </el-table-column>
        <el-table-column  prop="syNumber" label="次卡次数"  align="center" v-if="isCard == 0">
        </el-table-column>
         <el-table-column  prop="StaffName" label="业务员"  align="center">
        </el-table-column>
        <el-table-column  prop="Note" label="备注"  align="center">
        </el-table-column>
        
        <!-- <el-table-column prop="addTime" label="创建时间" >
        </el-table-column>
        <el-table-column prop="ShopName" label="商户名称" >
        </el-table-column> -->
      <!-- <el-table-column sortable prop="editUser" label="修改人" width="300">
      </el-table-column> -->
      <el-table-column align="center" label="操作" width="370"  fixed="right" >
        <template slot-scope="scope">
          <el-button el-button size="mini" type="primary" @click="handleDetail(scope.row)">详情</el-button>
          <el-button type="warning" v-if="isCard == 0 && q8 == true" plain size="mini" @click="handleCi(scope.row)">充值次数</el-button>
          <!-- <el-button type="warning" v-if="q9 == true" plain size="mini" @click="handlePassword(scope.row)">分配业务员</el-button> -->
          <el-button size="mini" type="danger"  @click="handleChong(scope.row)" v-if="q7 == true && isCard == 0 ">充值金额</el-button>
   
          <!-- <el-button size="mini" type="success"  @click="handlZi(scope.row)">子账号</el-button> -->
          <!-- <el-button v-if="isCard == 0 && q8 == true" size="mini" type="success"  @click="handleCi(scope.row)">充值次数</el-button> -->
          <!-- <el-button size="mini" type="info" @click="deleteUser(scope.row)" v-if="q3 == true">删除</el-button> -->
          <el-popover placement="bottom" trigger="hover">
                <div class style="width:80%">
                                  <div class="flexc-cen-x cursor" style="height: 30px"  v-if="q2 == true"   @click="handleEdit(scope.row)">
                    <i class="el-icon-edit"></i>
                    <div style="margin-left: 10px; color: #65a8ff">编辑</div>
                  </div>
                  <div class="flexc-cen-x cursor" style="height: 30px" v-if="q3 == true" @click="deleteUser(scope.row)">
                    <i class="el-icon-delete"></i>
                    <div style="margin-left: 10px; color: #65a8ff">删除</div>
                  </div>
                 <div class="flexc-cen-x cursor" style="height: 30px" v-if="q9 == true" @click="handlePassword(scope.row)">
                    <i class="el-icon-document-copy"></i>
                    <div style="margin-left: 10px; color: #65a8ff">分配业务员</div>
                  </div>
                 <div class="flexc-cen-x cursor" style="height: 30px" v-if="q11 == true"  @click="handlebang(scope.row)">
                    <i class="el-icon-video-pause"></i>
                    <div style="margin-left: 10px; color: #65a8ff">微信解绑</div>
                  </div>
                  <div class="flexc-cen-x cursor" style="height: 30px" v-if="q10 == true && issjjhcf==0"    @click="handlZi(scope.row)">
                    <i class="el-icon-share"></i>
                    <div style="margin-left: 10px; color: #65a8ff">子账号</div>
                  </div>


                </div>
                <el-button
                  size="mini"     
                  slot="reference"
                >更多操作</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 分页组件 -->

    <!-- 编辑界面 -->
    <el-drawer :wrapperClosable= false :title="title" :visible.sync="editFormVisible" :direction="direction" size="40%">
    <!-- <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click="closeDialog"> -->
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm" style="margin-bottom:150px">
         <el-form-item label="姓名:" prop="Name">
          <el-input size="small" v-model="editForm.Name" auto-complete="off" placeholder="请输入姓名"  style="width: 215px"></el-input>
        </el-form-item>
        <el-form-item label="手机号:" prop="Phone">
          <el-input size="small" v-model="editForm.Phone" auto-complete="off" placeholder="请输入手机号" style="width: 215px"></el-input>
        </el-form-item>
        <el-form-item :label="WZHYName+'编号:'" prop="MemberCard">
          <el-input size="small" v-model="editForm.MemberCard"  placeholder="请输入编号" style="width: 215px"></el-input>
        </el-form-item>
          <el-form-item :label="WZHYName+'头像:'" prop="HeadUrl">
                <div class="list-img-box cursor">
                  <div v-if="editForm.HeadUrl !== ''">
                    <img
                      :src="editForm.HeadUrl"
                      style="height: 100px;width:100px"
                      alt="图片"
                        @click="uploadPicture('HeadUrl')"
                    />
                  </div>
                  <div
                    v-else 
                    class="upload-btn"
                    style="height: 100px;width:100px"
                    @click="uploadPicture('HeadUrl')"
                  >

                    <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                    
                  <div class="flex-xy">
                       <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                        <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                  </div>

                    <!-- <span>封面设置</span> -->
                  </div>
                </div>
                <input
                  type="hidden"
                  v-model="editForm.HeadUrl"
                  placeholder="请添加头像"
                />
          </el-form-item>
         <el-form-item :label="WZHYName+'等级:'" v-if="isdengji == 1" prop="LevelID">
            <el-select v-model="editForm.LevelID" placeholder="请选择" size="small">
                <el-option
                  v-for="item in typeList"
                  :key="item.ID"
                  :label="item.LevelName"
                  :value="item.ID">
                </el-option>
              </el-select>
              <el-button type="text" @click="toSetting">设置</el-button>
           </el-form-item>
           <el-form-item label="能力" v-if="isxynl == 1" prop="LevelID">
            <el-select v-model="editForm.CapacityID" placeholder="请选择" size="small">
                <el-option
                  v-for="item in typeListCapacity"
                  :key="item.ID"
                  :label="item.CapacityName"
                  :value="item.ID">
                </el-option>
              </el-select>
              <!-- <el-button type="text" @click="toSetting">设置</el-button> -->
           </el-form-item>
         <el-form-item label="性别:" prop="Sex">
          <el-radio-group v-model="editForm.Sex">
             <el-radio :label="1">男</el-radio>
             <el-radio :label="2">女</el-radio>
           </el-radio-group>
          <!-- <el-input size="small" v-model="editForm.LoginName" auto-complete="off" placeholder="请输入登录账号"></el-input> -->
        </el-form-item>
        <el-form-item label="出生日期:" prop="Birthday" size="small">
          <el-date-picker
            v-model="editForm.Birthday"
            type="date"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="登记日期:" prop="OpenTime" size="small">
          <el-date-picker
            v-model="editForm.OpenTime"
            type="date"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="地址:" prop="Address">
          <el-input size="small" placeholder="请输入地址" v-model="editForm.Address"  auto-complete="off" style="width:90%"></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="Note">
            <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="editForm.Note" style="width:90%"></el-input>
        </el-form-item>
        <!-- v-if="isCard == 0" -->
        <el-form-item label="充值储蓄金额:" prop="czAmount" v-if="isCard == 0 && title == '添加'">
            <el-input size="small" placeholder="请输入储蓄金额" v-model="editForm.czAmount"  auto-complete="off" style="width: 215px"></el-input>元
        </el-form-item>
        <el-form-item label="充值次数:" prop="syNumber" v-if="isCard == 0 && title == '添加'">
          <el-input-number v-model="editForm.syNumber" :step="1" :min="0" step-strictly></el-input-number> 次
        </el-form-item>
        <el-form-item label="购买储蓄金额:" prop="GMAmount" v-if="isCard == 0 && title == '添加'">
            <el-input size="small" placeholder="请输入金额" v-model="editForm.GMAmount"  auto-complete="off" style="width: 215px"></el-input>元
        </el-form-item>
        <el-form-item label="购买次数金额:" prop="GMAmountCK" v-if="isCard == 0 && title == '添加'">
          <el-input size="small" placeholder="请输入金额" v-model="editForm.GMAmountCK"  auto-complete="off" style="width: 215px"></el-input>元
        </el-form-item>
        <el-form-item label="购买日期:" prop="GMtime" size="small" v-if="isCard == 0 && title == '添加'">
          <el-date-picker
            v-model="editForm.GMtime"
            type="date"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="业务归属人:" prop="StaffID" v-if="title == '添加'">
            <span>{{personName}}</span>
            <el-button @click="handlePassword1()" type="text">选择</el-button>
              <el-button bian v-if="personName!=''"  @click="toDelPer()" icon="el-icon-delete"  type="text" style="margin-left:30px"></el-button>
          <!-- <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="editForm.Note" style="width:90%"></el-input> -->
        </el-form-item>
      </el-form>

        <div class="demo-drawer__footer flex-r-x" style="width:40%">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
       
            @click="submitForm('editForm')"
            >保存</el-button
          >
        </div>
    </el-drawer>

    <el-dialog
                  title="裁切封面"
                  :visible.sync="cropperModel"
                  width="1200px"
                  center
                >
                <cropper-image
                    :Name="cropperName"
                    @uploadImgSuccess="handleUploadSuccess"
                    ref="child"
                    :key="timer"
                  >
                  </cropper-image> 
    </el-dialog>
            <!--查看大封面-->
    <el-dialog title="查看大封面" :visible.sync="imgVisible" center>
              <img
                :src="imgName"
                v-if="imgVisible"
                style="width: 100%"
                alt="查看"
              />
    </el-dialog>


    <el-dialog title="储蓄卡充值" :visible.sync="chongShow" width="40%" >
      <el-form label-width="120px">
        <el-form-item label="充值金额" prop="money">
          <el-input size="small" placeholder="请输入充值金额" v-model="money"  auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="购买金额" prop="GMAmount">
          <el-input size="small" placeholder="请输入金额" v-model="GMAmount"  auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="购买日期:" prop="GMtime" size="small" v-if="isCard == 0 && title == '添加'">
          <el-date-picker
            v-model="GMtime"
            type="date"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm" >
          <el-form-item label="业务归属人" >
              <div class="flexc-cen-x" style="width:100%">
                  <div style="display:flex;flex-wrap:wrap;">
                      <div style="margin-left:5px">{{personName}}                    
                      </div>
                  </div>
                  <div>
                      <el-button bian  @click="toPerson()"  type="text" style="margin-right:10px;margin-left:10px">选择</el-button>
                      <el-button bian v-if="personName!=''"  @click="toDelPer()" icon="el-icon-delete"  type="text" style="margin-left:30px"></el-button>
                  </div>
                  
              </div>
            
            
          </el-form-item>
       </el-form>
        <el-form-item label="备注:" prop="Note">
            <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="Note" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="ADDmoney()">充值</el-button>
      </div>
    </el-dialog>
    <el-dialog title="次卡充值" :visible.sync="chongCi" width="40%">
      <el-form label-width="120px">
        <el-form-item label="充值次数" prop="number">
          <el-input size="small" placeholder="请输入充值次数" v-model="number"  auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="购买金额" prop="GMAmount">
          <el-input size="small" placeholder="请输入金额" v-model="GMAmount"  auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="购买日期:" prop="GMtime" size="small" v-if="isCard == 0 && title == '添加'">
          <el-date-picker
            v-model="GMtime"
            type="date"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm" >
          <el-form-item label="业务归属人" >
              <div class="flexc-cen-x" style="width:100%">
                  <div style="display:flex;flex-wrap:wrap;">
                      <div style="margin-left:5px">{{personName}}                    
                      </div>
                  </div>
                  <div>
                      <el-button bian  @click="toPerson()"  type="text" style="margin-right:10px;margin-left:10px">选择</el-button>
                      <el-button bian v-if="personName!=''"  @click="toDelPer()" icon="el-icon-delete"  type="text" style="margin-left:30px"></el-button>
                  </div>
                  
              </div>
            
            
          </el-form-item>
       </el-form>
       
        <el-form-item label="备注:" prop="Note">
            <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="Note" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="ADDCi()">充值</el-button>
      </div>
    </el-dialog>
    <el-dialog title="子账号" :visible.sync="ziShow" width="700px">
       <el-button size="mini" style="float:right;margin-top:-20px" type="primary" v-if="q4 == true" @click="editZi()">+ 添加</el-button>
    <el-table  :data="subList" highlight-current-row v-loading="loading"  element-loading-text="拼命加载中" style="width: 100%;margin-top:10px">
      <!-- <el-table-column align="center" type="selection" width="60">
      </el-table-column> -->
        <el-table-column  prop="Name" label="姓名" align="center" >
        </el-table-column>
        <el-table-column  prop="Phone" label="电话" align="center" >
        </el-table-column>
        <el-table-column v-if="isxynl==1" prop="CapacityName" label="能力" align="center" >
        </el-table-column>
        <!-- <el-table-column  prop="addTime" label="操作时间" align="center" >
        </el-table-column> -->
        <el-table-column  prop="Note" label="备注" align="center" >
        </el-table-column>
        <el-table-column align="center" label="操作" width="200"  fixed="right" >
          <template slot-scope="scope">
            <el-button size="mini" @click="editZi(scope.row)" v-if="q5 == true">编辑</el-button>
             <el-button size="mini" type="info" @click="deleteSub(scope.row)" v-if="q6 == true">删除</el-button>
          </template>
        </el-table-column>

    </el-table>
     <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->
        <!-- <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="ziShow = false">取消</el-button>
            <el-button size="small" type="primary" :loading="loading"  @click="save()">保存</el-button>
        </div> -->
    </el-dialog>
    <el-dialog :title="subTitle" :visible.sync="editSub" width="40%">
      <el-form label-width="120px" :model="form" :rules="rules1" ref="form">
        <el-form-item label="姓名" prop="Name">
          <el-input size="small" placeholder="请输入姓名" v-model="form.Name"  auto-complete="off"></el-input>
        </el-form-item>
                <el-form-item label="电话" prop="Phone">
          <el-input size="small" placeholder="请输入电话" type="number" v-model="form.Phone"  auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="Note">
            <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="form.Note" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editSub = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="sureSub('form')">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="分配业务员" :visible.sync="passShow" width="40%">
       <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm" >
          <el-form-item :label="WZYGName+'：'" >
              <div class="flexc-cen-x" style="width:100%">
                  <div style="display:flex;flex-wrap:wrap;">
                      <div style="margin-left:5px">{{personName}}                    
                      </div>
                  </div>
                  <div>
                      <el-button bian  @click="toPerson()"  type="text" style="margin-right:10px;margin-left:10px">选择</el-button>
                      <el-button bian v-if="personName!=''"  @click="toDelPer()" icon="el-icon-delete"  type="text" style="margin-left:30px"></el-button>
                  </div>
                  
              </div>
            
            
          </el-form-item>
       </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="passShow = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="topass()">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="'选择'+WZYGName" :visible.sync="personShow" width="500px" @click="passShow = false">
        <div class="dialogMain" style="width:100%;height:400px">
            <el-collapse accordion  >
                <el-collapse-item v-for="(items) in personList" :key="items.ID" >
                    <template slot="title">
                            <!-- <img src="../../assets/icon/choose.png" alt="" style="width:18px;height:18px">   -->
                            <span style="margin-left:5px">{{items.Name}}</span>
                    </template>
                    <div class="cursor" v-for="item in items.listsub" :key="item.ID" style="margin-left:20px" @click="choose(item)" >
                        <div class="flex-spc-x" style="margin-top:5px" > 
                            
                            <div style="margin-left:5px;font-size:15px">
                                {{item.Name}}
                            </div>
                            <el-button type="text">选择</el-button>
                        </div> 
                        
                    </div>
                </el-collapse-item>

            </el-collapse>

        </div>
    </el-dialog>
     <el-dialog title="等级" :visible.sync="vipShow" width="600px" @click="vipShow = false">
       <div class="flex-spc-x" style="margin-top:-20px">
         <div></div>
          <el-button size="mini" type="primary" icon="el-icon-plus" @click="handleEdit1()">添加</el-button>
       </div>
        
      <el-table  :data="typeList" highlight-current-row v-loading="loading" size="mini"  element-loading-text="拼命加载中" style="width:100%;margin-top:10px">
        <el-table-column  prop="LevelName" label="等级名称">
            
        </el-table-column>
       
        <el-table-column  prop="preferentialvalue" label="折扣" align="center" >
          <template slot-scope="scope">
            <div class="flex-xy">
              <div v-if="scope.row.preferentialType == 0 " style="margin-top:5px;font-size:15px">无</div>
              <div v-if="scope.row.preferentialType == 1 " style="margin-top:5px;font-size:15px">{{scope.row.preferentialvalue}}元</div>
              <div v-if="scope.row.preferentialType == 2 " style="margin-top:5px;font-size:15px">{{scope.row.preferentialvalue}}%</div>
            </div>
          </template>
        </el-table-column>


      <el-table-column align="center" label="操作" width="200" >
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit1(scope.row)" >编辑</el-button>
          <el-button size="mini" type="info" @click="deleteUser1(scope.row)" >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
     </el-dialog>
  <el-drawer :wrapperClosable= false :title="title1" :visible.sync="editFormVisible1" :direction="direction" size="30%">
 
      <el-form label-width="120px" :model="editForm1" :rules="rules2" ref="editForm1">
         <el-form-item label="等级名称:" prop="LevelName">
          <el-input size="small" v-model="editForm1.LevelName" auto-complete="off" placeholder="请输入等级名称"  style="width: 215px"></el-input>
        </el-form-item>
         <!-- <el-form-item label="优惠类别:" prop="preferentialType">
            <el-radio-group v-model="editForm.preferentialType">
                <el-radio :label="0">无</el-radio>
                <el-radio :label="1">减免</el-radio>
                <el-radio :label="2">打折</el-radio>
            </el-radio-group>
         </el-form-item> -->
        <el-form-item v-if="editForm1.preferentialType == 1" label="优惠金额:" prop="preferentialvalue">
          <el-input type="Number" size="small" v-model="editForm1.preferentialvalue" auto-complete="off" placeholder="请输入优惠金额"  style="width: 215px"></el-input>
        </el-form-item>
        <el-form-item v-if="editForm1.preferentialType == 2" label="折扣:" prop="preferentialvalue">
          <el-input type="Number" size="small" v-model="editForm1.preferentialvalue" auto-complete="off" placeholder="请输入折扣"  style="width: 215px"></el-input> %
        </el-form-item>

    
      </el-form>
 
        <div class="demo-drawer__footer flex-r-x"  style="width:30%">
          <el-button size="small" @click="editFormVisible1 = false">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
            class="title"
        
            @click="submitForm1('editForm1')"
            >保存</el-button
          >
        </div>
    </el-drawer>
     <el-dialog
      title="提示"
      :visible.sync="isCompare"
      size="60%"
      center
      >
       <span slot="title">
        <p>
          提示
        </p>
      </span>
      <div class="flexC">
          <span  v-if="isEdit && issjjhcf==0"  style="margin-top:5px;">您在修改会员的手机号，如需修改点击继续修改，如需修改完并解绑微信请点击修改并解绑按钮。 </span> &nbsp;
          <span  v-if="isEdit && issjjhcf==1"  style="margin-top:5px;">您在修改会员的手机号，如需修改完并解绑微信请点击修改并解绑按钮。 </span> &nbsp;

      </div>
      <div class="flexC">
           <span v-if="!isEdit" style="margin-top:5px;">该手机号已存在是否将该手机加入主账号 </span> &nbsp;
          <span v-if="isEdit && isMain ==1" style="margin-top:5px;">该会员是主账号修改手机号将会将下面的子账号手机号全部修改为当前手机号 </span> &nbsp;
          <span v-if="isEdit && isMain ==0 && listlogin.length>0" style="margin-top:5px;">该会员是子账号修改手机号已存在主账号是否将其归入该主账号 </span> &nbsp;
       </div>
      <div class="drawerForm" v-if="listlogin.length>0">
          <el-table class="memberTable" :data="listlogin" ref="AdminHypeTable" :row-key="row => row.index" >
                            <template slot="empty">
                                <!-- <img src="../../assets/image/noData.svg" alt style="margin-top:50px;"> -->
                                <p style="text-align:center;margin-bottom:50px;">暂无数据</p>
                            </template>
                    
                            <el-table-column label="姓名" prop="Name"></el-table-column>
                            <el-table-column label="账号类别"  >
                                <template slot-scope="scope" class="flexB">
                                   <span style="color: red" v-if="scope.row.isMain ==1">主账号</span>
                                   <span v-if="scope.row.isMain ==0">子账号</span>
                                </template>
                            </el-table-column>
               
                        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isCompare = false">取 消</el-button>
        <el-button v-if="!isEdit" type="primary" @click="CompareAdd">确 定</el-button>
        <el-button v-if="isEdit && issjjhcf==0" type="primary" @click="CompareEdit">继续修改</el-button>
        <el-button v-if="isEdit" type="primary" @click="CompareEdit1">修改并解绑</el-button>
      </span>
    </el-dialog>

     <el-dialog
      title="提示"
      :visible.sync="isCompare1"
      size="60%"
      center
      >
       <span slot="title">
        <p>
          提示
        </p>
      </span>
      <div class="flexC">
          <span v-if="issjjhcf==0" style="margin-top:5px;">您在修改会员的手机号，如需修改点击继续修改，如需修改完并解绑点击修改并解绑。 </span> &nbsp;
          <span v-if="issjjhcf==1" style="margin-top:5px;">您在修改会员的手机号 ，如需修改完并解绑点击修改并解绑。 </span> &nbsp;

        </div>
       
      <span slot="footer" class="dialog-footer">
        <el-button @click="isCompare1 = false">取 消</el-button>
        <el-button type="primary" v-if="issjjhcf==0" @click="CompareEdit">继续修改</el-button>
                <el-button type="primary" @click="CompareEdit1">修改并解绑</el-button>

      </span>
    </el-dialog>

    <el-dialog
      title="导入会员信息"
 
      :visible.sync="dialogdrVisible"
      width="40%"
        >     
           <div class="student-basic-import">
     
            <div class="ant-row step-section">
                   <h4 class="step-title">1.下载导入模板，按要求填写信息</h4>
                   <el-button type="text" @click="downdemo">下载会员信息导入模板</el-button>
                   <!-- <div @click="downdemo"  class="set-link">下载会员信息导入模板</div> -->
                </div>
                <div class="ant-row step-section">
                   <h4 class="step-title">2.选择需要导入的Excel文件</h4>
                   <div class="pull-right" >
                        <el-upload
                             class="upload-demo"
                             ref="upload"
                             action="doUpload"
                             :limit="1"
                              :before-upload="beforeUpload">
                             <el-button slot="trigger" size="small" type="primary"  style="margin-right: 20px">上传excel</el-button>
                           <div slot="tip" class="el-upload__tip">只能上传excel文件</div>
                           <div slot="tip" class="el-upload-list__item-name">{{fileName}}</div>
                        </el-upload> 
                 
                    </div>
                 </div>
           </div>
   
          <span slot="footer" class="dialog-footer1">
        <el-button @click="dialogdrVisible = false">取 消</el-button>
        <el-button type="primary"  @click="submitUpload">开始导入</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import CropperImage from "../../components/CropperImage";
import {getListManageLogin,addManageLogin,delManageLogin,editManageLogin,editManageLoginmoney,editManageLoginPwd,editManageLoginIsdisable} from "@/api/getData";
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      editFormVisible1:false,
      imgVisible:false,
      cropperModel:false,
      isCompare:false,
      isCompare1:false,
       isMain:0,
       isEdit:false,
      direction: "ltr",
      passShow:false,
      typeList:[],
      typeListCapacity:[],
      tableData1:[],
      DianList:[],
      listlogin:[],
      money:'',
      number:'',
      MembersID:'',
      SelectStoresID:localStorage.getItem("StoresID"),
      isxynl:localStorage.getItem("isxynl"),
      issjjhcf:localStorage.getItem("issjjhcf"),
      chongCi:false,
      input:'',
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      chongShow:false,
      title: '添加',
      timer:'',
      selectName:'',
      cropperName:'',
      tableData:[],
      editSub:false,
      isdengji:localStorage.getItem('isdengji'),
      rules2: {
        LevelName: [{ required: true, message: '请输入等级名称', trigger: 'blur' }],
        //   Phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        //   Name: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        //   pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        //   money: [{ required: true, message: '请输入余额', trigger: 'blur' }],
        //   ShopName: [{ required: true, message: '请输入商户名称', trigger: 'blur' }],
      },
      Pwd:'',
      id:'',
      personShow:false,
      isCard:localStorage.getItem('isCard'),
      personList:[],
      subList:[],
      subTitle:'',
      form:{
        Note:'',
        Name:'',
        Phone:'',
      },
           editForm1: {
        preferentialType:2,
        LevelName:'',
        preferentialvalue:'',
      },
      editForm: {
        MemberCard:'',
        LoginName:"",
        Phone:"",
        Name:"",
        pwd:"",
        money:"",
        ShopName:"",
        HeadUrl:'',
        Sex:2,
        Address:'',
        Birthday:'',
        OpenTime:'',
        LevelID:'',
        StaffID:'',
        isaddzi:0,
        iscz:0,
        isjiebang:0,
 
      },
      ziShow:false,
      Note:'',
      Limits:[],
      q1:false,
      q2:false,
      q3:false,
      q4:false,
      q5:false,
      q6:false,
      q7:false,
      q8:false,
      q9:false,
      q10:false,
      q11:false,
      q8241:false,

      
      // rules表单验证

      rules: {
          MemberCard: [{ required: true, message: '请输入编号', trigger: 'blur' }],
          LoginName: [{ required: true, message: '请输入登录账号', trigger: 'blur' }],
          Phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
          Name: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
          pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
          money: [{ required: true, message: '请输入余额', trigger: 'blur' }],
          ShopName: [{ required: true, message: '请输入商户名称', trigger: 'blur' }],
      },

      rules1: {
          Name: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
          Phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      personList:[],
      userparm: [], //搜索权限
      listData: [], //用户数据
      CardID:'',
      ListMemberCard:[],
          WZYGName:'',
    WZHYName:'',
    WZXMName:'',

    LevelName:'',
    WZPBName:'',
    title1:'',

    vipShow:false,
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      personName:"",
      StaffID:'',
      GMAmount:'',
      GMtime:'',
      files:{},
      fileName:"",
      dialogdrVisible:false,
      multipleSelection:[],
      
    }
  },
  // 注册组件
  components: {
    Pagination,
     CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
        this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
     if(localStorage.getItem('isAdmin') == 1){
          this.q1 = true
          this.q2 = true
          this.q3 = true
          this.q4 = true
          this.q5 = true
          this.q6 = true
          this.q7 = true
          this.q8 = true
          this.q9 = true
          this.q10 = true
          this.q11 = true
          this.q8241 = true

          
      }
    this.Limits = localStorage.getItem('Limits')
      this.Limits = this.Limits.split(',')
      this.Limits.forEach(items => {
          if(items == 822){
            this.q1 = true
          }
          if(items == 823){
            this.q2 = true
          }
          if(items == 824){
            this.q3 = true
          }
          if(items == 825){
            this.q4 = true
          }
          if(items == 826){
            this.q5 = true
          }
          if(items == 827){
            this.q6 = true
          }
          if(items == 828){
            this.q7 = true
          }
          if(items == 829){
            this.q8 = true
          }
          if(items == 8222)
          this.q9 = true
          if(items == 8251)
           this.q10 = true
          if(items == 8223)
          this.q11 = true
          if(items == 8241)
          this.q8241 = true
          
   })

      this.getList()
      this.getType()
      this.gettypeListCapacity()
      this.getList1()
      this.getDianList()

      this.getPersonList()
      this.getListMemberCard();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    submitForm1(editData) {

      this.$refs[editData].validate(valid => {
        if (valid) {
            var data = this.editForm1
                data.token=localStorage.getItem("token")
                data.StoresID=localStorage.getItem("StoresID")
                data.SelectStoresID  = this.SelectStoresID
                var that = this
            if(this.title1 == '添加等级'){
                this.ajax('addMembersLevel.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "新建成功",duration:2000,
                        });
                        that.editFormVisible1 = false
                        that.getType()
                     }

                })

            }else {
                data.MembersLevelID =  this.editForm1.ID
                 this.ajax('editMembersLevel.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "修改成功",duration:2000,
                        });
                        that.editFormVisible1 = false
                        that.getType()
                     }

                })
            }
        } else {
          return false
        }
      })
    },  handleSelectionChange(val) {
                this.multipleSelection = val;
      },delAllMembersClick(){
                let arr = [];
                let ArrayString;
                this.multipleSelection.forEach(element => {
                    arr.push(element.ID)
                });
                console.log(arr)
                if(arr.length>0){
                    ArrayString = arr.join();
                }else{
                  this.$message({ type: "error", message: '请选择会员' });
                  return;
                }
                this.$confirm('确定删除？一旦删除该会员关联的数据将全部被删除，不可恢复。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
          }).then(() => {
            this.delAllMembers(ArrayString);
          }).catch(() => {
                    
        });
            },delAllMembers(ArrayString){
              var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MembersIDs:ArrayString
        
        }
        var that = this
        this.ajax('delAllMembers.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
        
              that.getType()
              that.getList()
             }

        })
            },
     deleteUser1(row){
        this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MembersLevelID:row.ID,
        
        }
        var that = this
        this.ajax('delMembersLevel.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
        
              that.getType()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
   
    },doupdExcl(){
      this.dialogdrVisible = true;

    },downdemo(){window.open("http://tp.xingxingzhihuo100.com/YYXB/download/导入会员模板.xls");
 
                                 }, beforeUpload(file){
                 console.log(file,'文件');
                this.files = file;
                const extension = file.name.split('.')[1] === 'xls'
                const extension2 = file.name.split('.')[1] === 'xlsx'
                 if (!extension && !extension2) {
                    this.$message.warning('上传模板只能是 xls、xlsx格式!')
                    return
                }
                
                this.fileName = file.name;
               // setTimeout(() => {
                 //   this.submitUpload();
               // },500);
                return false; // 返回false不会自动上传
            },  submitUpload() {
                // console.log('files:'+this.files)
                // console.log('fileName:'+this.fileName)

                if(this.fileName == ""){
                    this.$message.warning('请选择要上传的文件！')
                    return false
                }
                 this.UpdStuExcel();
           
               
           
            },UpdStuExcel(){
              let fileFormData = new FormData();
                fileFormData.append("code", "t_pathology_info_excel");
                fileFormData.append("description", "excel");
                //filename是键，file是值，就是要传的文件，test是要传的文件名
                fileFormData.append('file', this.files, this.fileName);
                fileFormData.append("token", localStorage.getItem("token"));

        
                   var elem = this;
                  const loading = this.$loading({
                       lock: true,
                         text: '加载中',
                          spinner: 'el-icon-loading',
                     background: 'rgba(0, 0, 0, 0.7)'
                 })
                 var loginUrl =  "https://sapi.yuyuexiaobao.cn/WebApi/UpdStuExcel.aspx"
              
                  fetch(loginUrl, {
       method: 'post',
       headers: {
           
          'Access-Control-Allow-Origin':'*',
				'Accept': 'application/json'
         },
       body: fileFormData,
       }).then(response => response.json())
       .then((data) => {
            console.log(data);
             loading.close()

            if(data.orsuccess == '1'){
             
               
              elem.getList()

            }else{
                this.$message({ type: "error", message: data.Msg });

            }

            elem.dialogdrVisible = false;

        });
 
                
            },getListMemberCard(){
      var data = { SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          CardType:0
      }

       var that = this
      this.ajax('getListMemberCard.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                 that.ListMemberCard= res.data
 
          } 
       })
    },
        handleEdit1(row){
          if (row != undefined && row != 'undefined') {
              this.title1 = '编辑等级'
              this.editForm1 = row
              this.editForm1.preferentialType = Number(this.editForm1.preferentialType) 
    
          } else {
              this.title1 = '添加等级'
                this.editForm1 = {
                    preferentialType:2,
                    LevelName:'',
                    preferentialvalue:100,
                }
          }
          this.editFormVisible1 = true
    },
    handlePassword1(){
        this.personShow = true
    },
    toSetting(){
      this.getType()
      this.vipShow = true
      // this.$router.push({
      //   path:`/vip/vipLevel`
      // })
    },
  handlePassword(row){

      this.editForm.ManageLoginID = row.ID
      this.personName = row.StaffName
      this.StaffID = row.StaffID
      this.passShow = true

    },
    topass(){
      var data = { 
          MembersID:this.editForm.ManageLoginID,
          SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StaffID:this.StaffID,
        }
        var that = this
        this.ajax('editMembersStaff.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "分配成功",duration:2000,
              });
              that.passShow = false
              that.getList()
              //  that.provinceList = res.data
            }

        })
    },
      choose(items){
      
        this.personName = items.Name
          this.StaffID = items.ID

          this.personShow = false
       
          this.editForm.StaffID = items.ID
      },
      toDelPer(){
        this.editForm.StaffID =''
        this.personName = ''
        this.StaffID = ''
      },
     getPersonList(){
           var data = { 
            SelectStoresID:this.SelectStoresID,
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID"),
            pages:1,
            psize:100,
         }
        var that = this
       this.ajax('getlistStaffgl.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.personList = res.data
               
            }

      })
      },
    toPerson(){
        this.personShow = true
    },
    editZi(row){
        if(row){
          
          this.form =row
          if(this.form.LevelID == 0){
            this.form.LevelID = ''
          }
        this.subTitle = '修改子账号'
        } else {
          this.subTitle = '添加子账号'
        }
        this.editSub = true
    },
    handlZi(row){
      this.id = row.ID

     
        var that = this
        this.getSubList()
    },
    getSubList(){
       var data = { 
         SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          MembersID:this.id,
          }
          var that = this
       this.ajax('getListMembersSub.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
               that.subList = res.data      
            }
      })
      this.ziShow = true
    },
    getDianList(){
       var data = { 
         SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID")
      }
        var that = this
       this.ajax('getListStores.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
               that.DianList =res.data      
            }
      })
},

  changedian(){
      this.pageparm ={
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      this.getType()
      this.getList()
      this.getPersonList()
      this.getListMemberCard();

    },
    uploadPicture(name) {
      this.timer = new Date().getTime()
      this.cropperName = name;
      this.cropperModel = true;
    },
    handleUploadSuccess(data) {
          this.cropperModel = false
          this.editForm.HeadUrl = data.url
 
  },
  handleDetail(row){
    
    localStorage.setItem("SelectStoresID", this.SelectStoresID);
    this.$router.push({ 

          path: `/vip/vipDetail/${row.ID}`,

      })

  },
      getList1(){

    //  this.tableLoading = true
       var data = { SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:1,
          psize:100,
          StaffTypeID:''
      }
     
      
        var that = this
      this.ajax('getListStaff.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.personList = res.data
            
          } 

      })
  
  
    },
    handlebang(row){
      this.$confirm("确定要解绑微信吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { 
            MembersID:row.ID,
            SelectStoresID:this.SelectStoresID,
            StoresID:localStorage.getItem("StoresID"),
            token: localStorage.getItem("token")
        }
        var that = this
        this.ajax('wxjiebang.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "解绑成功",duration:2000,
              });
                    
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
    },
    deleteSub(row){
    
        this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { 
            MembersSubID:row.ID,
            SelectStoresID:this.SelectStoresID,
            StoresID:localStorage.getItem("StoresID"),
            token: localStorage.getItem("token")
        }
        var that = this
        this.ajax('delMembersSub.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
             that.getSubList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
    },
        deleteUser(row){
        this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MembersID:row.ID,
        
        }
        var that = this
        this.ajax('delMembers.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
              that.getType()
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
   
    },gettypeListCapacity(){
        var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
      
      }
   
        var that = this
      this.ajax('getListMembersCapacity.aspx ',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                 that.typeListCapacity = res.data
           } 

      })

    },
  getType(){
       var data = { SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
            pages:1,
            psize:100,
      }
      var that = this
      this.ajax('getListMembersLevel.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
  
                that.typeList = res.data
                //  loading.close();
          } 
       })
    
    },
    getList(){

    //  this.tableLoading = true
       var data = { SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:this.formInline.page,
          psize:this.formInline.limit,
          selectName:this.selectName,
          MembersType:1,
          CardID:this.CardID
          // ProjectTypeID:this.active
          // StaffTypeID:this.active
      }
       const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      
        var that = this
      this.ajax('getListMembers.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.tableData = res.data
                that.pageparm.total = res.allcount

                 loading.close();
          } 

      })
  
    },

    handleCi(row){
     this.id = row.ID
      this.chongCi = true
      this.number = ''
      this.Note=''
      this.GMAmount = ''
      this.personName = row.StaffName
      this.StaffID = row.StaffID
         var date = new Date();
          var year = date.getFullYear();
          var month = date.getMonth() + 1;
          var day = date.getDate();
          if (month < 10) {
          month = '0' + month;
          }
          if (day < 10) {
          day = '0' + day;
          }
          var nowDate = year + '-' + month + '-' + day;
          this.GMtime = nowDate
    },
    handleChong(row){
      this.id = row.ID
      this.chongShow = true
      this.money = ''
        this.GMAmount = ''
      this.Note=''
      this.personName = row.StaffName
      this.StaffID = row.StaffID
        var date = new Date();
          var year = date.getFullYear();
          var month = date.getMonth() + 1;
          var day = date.getDate();
          if (month < 10) {
          month = '0' + month;
          }
          if (day < 10) {
          day = '0' + day;
          }
          var nowDate = year + '-' + month + '-' + day;
          this.GMtime = nowDate
    },
    ADDCi(){
         var data = { SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          LoginID:localStorage.getItem('LoginID'),
          MembersID:this.id,
          syNumber:this.number,
          GMAmount:this.GMAmount,
          Note:this.Note,
          StaffID:this.StaffID,
          GMtime:this.GMtime,
      }
        var that = this
        this.ajax('editMemberssyNumber.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
     
               that.tableData = res.data
     
               that.$message({
                            type: "success",
                            message: "充值成功",duration:2000,
                  });
            that.chongCi = false
            that.getList()
          } 

      })
    },
    ADDmoney(){
         var data = { 
           SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          LoginID:localStorage.getItem('LoginID'),
          MembersID:this.id,
          czAmount:this.money,
          GMAmount:this.GMAmount,
          StaffID:this.StaffID,
          GMtime:this.GMtime,
          Note:this.Note,

      }
        var that = this
        this.ajax('editMembersczAmount.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
     
                that.tableData = res.data
     
               that.$message({
                            type: "success",
                            message: "充值成功",duration:2000,
                  });
            that.chongShow = false
            that.getList()
          } 

      })
    },
    // 获取公司列表

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getList()
    },
    // 搜索事件
    search() {
      // this.getdata(this.formInline)
      this.getList()
    },handleExport(){
     // 
     var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          selectName:this.selectName,
          MembersType:1
          // ProjectTypeID:this.active
          // StaffTypeID:this.active
      }
       const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      
        var that = this
      this.ajax('ExportMemberInfo.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                // that.tableLoading = false
                // that.tableData = res.data
                // that.pageparm.total = res.allcount
                window.open(res.xlsFile);
               // exportPDFfunGet(res.xlsFile);
                 loading.close();
          } 

      })
    },
    //显示编辑界面
    handleEdit: function(row) {
      
      this.personName = ''
      this.StaffID = ''
      if (row != undefined && row != 'undefined') {
        this.isEdit= true;
        this.title = '修改'
        this.editForm = row
        this.MembersID = this.editForm.ID;
        this.editForm.Sex = Number(this.editForm.Sex) 
        
         if(this.editForm.LevelID == 0 ){
           this.editForm.LevelID =''
         }
          this.editFormVisible = true
      } else {
        this.isEdit= false;
          this.getVIpCard()
        //  this.editForm.ManageLoginID = ''
        // this.editForm.LoginName = ''
        // this.editForm.Phone= ''
        // this.editForm.Name= ''
        // this.editForm.ShopName= ''
        // this.editForm.pwd=''
        // this.editForm.money=' '

      }
    },
   
    getVIpCard(){
      var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
         
          // ProjectTypeID:this.active
          // StaffTypeID:this.active
      }

      
        var that = this
      this.ajax('getMemberCode.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                // console.log(res.data)
               that.editForm={
                LoginName:"",
                Phone:"",
                Name:"",
                pwd:"",
                money:"",
                ShopName:"",
                HeadUrl:'',
                Sex:2,
                Address:'',
                Birthday:'2000-10-10',
                OpenTime:'',
                LevelID:'',
                StaffID:'',
                GMAmount:'',
                GMAmountCK:'',
                MemberCard:res.data,
                isaddzi:0,
                iscz:0,
                isjiebang:0,

            }
              var date = new Date();
          var year = date.getFullYear();
          var month = date.getMonth() + 1;
          var day = date.getDate();
          if (month < 10) {
          month = '0' + month;
          }
          if (day < 10) {
          day = '0' + day;
          }
          var nowDate = year + '-' + month + '-' + day;
          that.editForm.OpenTime = nowDate
          that.editForm.GMtime = nowDate
          that.title = '添加'
          that.editFormVisible = true
       
          } 

      })
    },
    sureSub(editData){
      this.$refs[editData].validate(valid => {
        if (valid) {
            if(this.subTitle == '添加子账号'){
              var data = this.form
                data.MembersID = this.id
                data.SelectStoresID  = this.SelectStoresID 
                data.token=localStorage.getItem("token")
                data.StoresID=localStorage.getItem("StoresID")
                var that = this
                 this.ajax('addMembersSub.aspx',JSON.stringify(data),"POST",function(res){
                  if (res.orsuccess == "1") {
                            that.$message({
                            type: "success",
                            message: "添加成功",duration:2000,
                          });
                        that.editSub = false
                        that.getSubList()
                        // that.get()
                      }

                  })
            } else {
                 var data = this.form
                data.MembersSubID = this.form.ID
                data.SelectStoresID  = this.SelectStoresID 
                data.token=localStorage.getItem("token")
                data.StoresID=localStorage.getItem("StoresID")
                var that = this
                 this.ajax('editMembersSub.aspx',JSON.stringify(data),"POST",function(res){
                  if (res.orsuccess == "1") {
                            that.$message({
                            type: "success",
                            message: "修改成功",duration:2000,
                          });
                        that.editSub = false
                        that.getSubList()
                        // that.get()
                      }

                  })
            }
          } 
        })
    },CompareEdit(){
                this.editForm.isjiebang =0;
                this.editMembers();
                
            },CompareEdit1(){
                this.editForm.isjiebang =1;
                this.editMembers();
                    
            }
    , CompareAdd(){
                this.editForm.isaddzi=1;
                this.addMember();
            },
            CompareMembers(isedit){
       var data = { 
          StoresID:localStorage.getItem("StoresID"),
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
           Phone:this.editForm.Phone,
           ISedit:isedit,
           MembersID:this.MembersID
        }
          var that = this
      this.ajax('CompareMembers.aspx',JSON.stringify(data),"POST",function(res){
                          

           if (res.orsuccess == "1") {
              that.isCompare=false;
                     if(that.isEdit){
                         that.editMembers();
                     }else
                     {
                      that.addMember();
                     }
       
          }else if(res.orsuccess == '2'){
 
                that.editForm.iscz = 2;
                    that.isCompare=true;
                    that.listlogin= res.data
                    that.isMain =0;
                 }else if(res.orsuccess == '3'){
                     that.editForm.iscz = 3;

                     that.listlogin= res.data
                                         that.isCompare=true;

                     that.isMain =0;
 
                }else if(res.orsuccess == '4'){
                    that.editForm.iscz = 4;
                    that.isCompare=true;
                     that.listlogin= res.data
                    that.isMain =0;
 
                }else if(res.orsuccess == '5'){
                    that.editForm.iscz = 5;
                    that.isCompare=true;
                     that.listlogin= res.data
                        that.isMain =res.isMain;
 
                }else if(res.orsuccess == '6'){
                    that.editForm.iscz = 6; 
                    that.isCompare=true;
                     that.listlogin= res.data
                     that.isMain =res.isMain;
 

                }else if(res.orsuccess == '7'){
                    that.isCompare1=true;
 
                }else{
                    this.$message({ type: "error", message: res.Msg ,duration:1000});
 
                } 

      })

    },addMember()
    {
        var that = this
            var data = this.editForm
            data.SelectStoresID  = this.SelectStoresID 
            data.token=localStorage.getItem("token")
            data.MembersType = 1
            data.StoresID=localStorage.getItem("StoresID")
               this.ajax('addMembers.aspx',JSON.stringify(data),"POST",function(res){
                  if (res.orsuccess == "1") {
                            that.$message({
                            type: "success",
                            message: "新建成功",duration:2000,
                          });
                        
                        that.isCompare=false;
                        that.isCompare1=false;
                        that.editFormVisible = false
                        that.getList()
                      }

                  })
    },editMembers(){

            var that = this
            var data = this.editForm
            data.SelectStoresID  = this.SelectStoresID 
            data.token=localStorage.getItem("token")
            data.MembersType = 1
            data.StoresID=localStorage.getItem("StoresID")
            data.MembersID = this.MembersID
             this.ajax('editMembers.aspx',JSON.stringify(data),"POST",function(res){
                     if (res.orsuccess == "1") {
                              that.$message({
                                    type: "success",
                                    message: "修改成功",duration:2000,
                                  });
                                  that.isCompare=false;
                                  that.isCompare1=false;
                                  that.editFormVisible = false
                                  that.getList()
                                }                                 

                    })         
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.issjjhcf==1){
              
              if(this.isEdit){
              this.CompareMembers(1);
          }else{
            this.CompareMembers(0);
          }
          }else{
            if(this.isEdit){
              this.editMembers();
          }else{
            this.addMember();
          }
          }
          
           
        } else {
          return false
        }
      })
  
    
    },

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.passShow = false,
      this.chongShow = false,
      this.editFormVisible = false
    }
  }
}
</script>

<style>

.el-popover{
  min-width:150px !important;
}
</style>

<style scoped>

.dilag-fix{
    position:absolute;
    right: 0;
    bottom: 0;
    margin-bottom: 10px;

}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.ivu-badge-status-dot {
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 50%;
    vertical-align: middle;
    position: relative;
    top: -1px;
}
  .ivu-badge-status-green {
    background-color: #52c41a;
}
.ivu-table-cell {
    padding-left: 10px;
    padding-right: 10px;
    white-space: pre-line;
    
}
</style>



// WEBPACK FOOTER //
// src/views/vip/vip.vue